import { useCallback } from 'react';

import saveUserHistory, {
  deriveConversationName
} from '@/features/AIChat/AskGXDrawer/utils/saveUserHistory';
import { useChat } from '@/features/AIChat/context/useChat';
import type { Message } from '@/features/AIChat/types/chat';
import isAiMessage from '@/features/AIChat/utils/isAiMessage';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';

export const useRateAnswer = () => {
  const { messages, setMessages, conversationId } = useChat();
  const dispatch = useAppDispatch();
  const userConfig = useAppSelector(state => state.userConfig.userConfig);

  const handleRate = useCallback(
    (targetId: string, score: -1 | 1) => {
      const nextMsgs: Message[] = messages.map(m =>
        m.id === targetId && isAiMessage(m) ? { ...m, rating: score } : m
      );
      setMessages(nextMsgs);
      if (!conversationId) return;

      const timestamp = new Date().toISOString();
      const existing = userConfig.chatHistory;
      const idx = existing.findIndex(c => c.conversationId === conversationId);
      const updatedConversation = {
        conversationId,
        messages: nextMsgs,
        timestamp,
        name: deriveConversationName(nextMsgs)
      };
      saveUserHistory({
        userConfig,
        dispatch,
        updatedConversation,
        existing,
        idx
      });
    },
    [conversationId, dispatch, messages, setMessages, userConfig]
  );

  return { handleRate, conversationId } as const;
};
